export default {"src":"/_next/static/media/piggyBank_24.5287003d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};